import type { ThemePalette } from "./types";

export const ccflareLight: ThemePalette = {
	id: "ccflare-light",
	name: "ccflare Light",
	family: "ccflare",
	appearance: "light",

	background: "#ffffff",
	foreground: "#0a0a0f",
	card: "#ffffff",
	cardForeground: "#0a0a0f",
	popover: "#ffffff",
	popoverForeground: "#0a0a0f",

	primary: "#f38020",
	primaryForeground: "#ffffff",
	secondary: "#f0f0f3",
	secondaryForeground: "#191920",
	muted: "#f0f0f3",
	mutedForeground: "#6e6e7a",
	accent: "#f38020",
	accentForeground: "#ffffff",
	destructive: "#e5484d",
	destructiveForeground: "#fafafa",

	border: "#e4e4e9",
	input: "#e4e4e9",
	ring: "#f38020",

	success: "#16a34a",
	warning: "#ca8a04",
	error: "#dc2626",
	info: "#2563eb",

	chart1: "#f38020",
	chart2: "#3b82f6",
	chart3: "#8b5cf6",
	chart4: "#ec4899",
	chart5: "#10b981",
};

export const ccflareDark: ThemePalette = {
	id: "ccflare-dark",
	name: "ccflare Dark",
	family: "ccflare",
	appearance: "dark",

	background: "#111318",
	foreground: "#f2f2f2",
	card: "#181b22",
	cardForeground: "#f2f2f2",
	popover: "#181b22",
	popoverForeground: "#f2f2f2",

	primary: "#f38020",
	primaryForeground: "#ffffff",
	secondary: "#262b33",
	secondaryForeground: "#f2f2f2",
	muted: "#262b33",
	mutedForeground: "#838996",
	accent: "#f38020",
	accentForeground: "#ffffff",
	destructive: "#e5484d",
	destructiveForeground: "#fafafa",

	border: "#2a303a",
	input: "#262b33",
	ring: "#f38020",

	success: "#3fb950",
	warning: "#d29922",
	error: "#f85149",
	info: "#58a6ff",

	chart1: "#f38020",
	chart2: "#58a6ff",
	chart3: "#bc8cff",
	chart4: "#f778ba",
	chart5: "#3fb950",
};
